import { ReactNode } from 'react';

import { Modal, Box } from '@mui/material';

type Params = {
    open: boolean;
    children: ReactNode;
    handleClick?: (value: boolean) => void;
    borderRadius?: string;
    bgcolor?: string;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    boxShadow: 24,
    outline: 'none',
    transform: 'translate(-50%, -50%)'
};

const Modals = ({ open, children, handleClick, borderRadius = '8px', bgcolor = 'background.paper' }: Params) => {
    return (
        <Modal open={open} onClose={() => handleClick && handleClick(false)}>
            <Box sx={style} borderRadius={borderRadius} bgcolor={bgcolor}>
                {children}
            </Box>
        </Modal>
    );
}

export default Modals;